import { gl } from '../../../Engine';
import { Uniform } from './Uniform';

export class UniformFloat extends Uniform {
    constructor(name: string) {
        super(name);
    }

    loadFloat(value: number) {
        if (this.location) {
            gl.uniform1f(this.location, value);
        }
    }
}
